import { ref } from "@vue/composition-api";
import {
  InputLiveChatInvitationCreate,
  InputLiveChatInvitationUpdate,
  LiveChatInvitation,
  LiveChatInvitationSubjectType,
  InputLiveChatInvitationSearch,
  LiveChatInvitationStatus,
} from "@scrile/api-provider/dist/api/LiveChatInvitationsProvider";
import providers from "@/lib/api";

export default function useLiveChatInvitation() {
  const invitations = ref<LiveChatInvitation[]>([]);

  const invitationsCreate = async ({
    chatId,
    type,
    recipientIds,
  }: {
    chatId: string;
    type: LiveChatInvitationSubjectType;
    recipientIds: string[];
  }) => {
    const data: InputLiveChatInvitationCreate[] = recipientIds.map(i => ({
      subject: { subjectId: chatId, subjectType: type },
      recipientId: i,
    }));

    const response = await providers.LiveChatInvitationsProvider.create({ data });
    invitations.value = [...response, ...invitations.value];
  };

  const invitationUpdate = async (data: InputLiveChatInvitationUpdate): Promise<LiveChatInvitation> => {
    return await providers.LiveChatInvitationsProvider.update({ data });
  };

  const cancelInvitation = async (id: string) => {
    await invitationUpdate({ id, status: LiveChatInvitationStatus.CANCELLED });
    invitations.value = invitations.value.filter(i => i.id !== id);
  };

  const invitationsSearch = async (data: InputLiveChatInvitationSearch) => {
    invitations.value = await providers.LiveChatInvitationsProvider.search({ data });
  };

  return {
    invitations,
    invitationsCreate,
    invitationUpdate,
    invitationsSearch,
    cancelInvitation,
  };
}
